import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaTwitter, FaInstagram, FaYoutube } from "react-icons/fa";
import "./Footer.css";

export default function Footer() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [socialLinks, setSocialLinks] = useState({
    facebook: "#",
    twitter: "#",
    instagram: "#",
    youtube: "#",
    email: "",
    mobile: "",
  });

  useEffect(() => {
    fetch(`${API_BASE_URL}footer_list.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({}), // API reads php://input, keep it valid
    })
      .then((res) => res.json())
      .then((data) => {
        if (data?.head?.code === 200 && data?.body?.length > 0) {
          const links = data.body[0];

          // 1️⃣ Store delivery charge in localStorage
        if (links.delivery_charge !== undefined) {
          localStorage.setItem(
            "delivery_charge",
            Number(links.delivery_charge).toFixed(2)
          );
        }

          setSocialLinks({
            facebook: links.facebook_link || "#",
            twitter: links.twitter_link || "#",
            instagram: links.instagram_link || "#",
            youtube: links.youtube_link || "#",
            email: links.email || "",
            mobile: links.mobile || "",
          });
        }
      })
      .catch((err) => {
        console.error("Footer API error:", err);
      });
  }, [API_BASE_URL]);

  return (
    <footer
      className="footer text-light pt-5"
      style={{ backgroundColor: "#0b1b30" }}
    >
      <div className="container">
        <div className="row mb-4 text-center text-md-start">
          <div className="col-md-3">
            <h4 className="fw-bold text-uppercase">Porvaall</h4>
            <p className="small text-white-50">
              Explore thousands of magazines, trending articles, 
              from around the world — all in one place.
            </p>

            <div className="d-flex gap-3 justify-content-center justify-content-md-start mt-3 mb-3">
              <a href={socialLinks.facebook} target="_blank" rel="noreferrer" className="text-light">
                <FaFacebookF size={18} />
              </a>

              <a href={socialLinks.twitter} target="_blank" rel="noreferrer" className="text-light">
                <FaTwitter size={18} />
              </a>

              <a href={socialLinks.instagram} target="_blank" rel="noreferrer" className="text-light">
                <FaInstagram size={18} />
              </a>

              <a href={socialLinks.youtube} target="_blank" rel="noreferrer" className="text-light">
                <FaYoutube size={18} />
              </a>
            </div>
          </div>

          <div className="col-md-3">
            <h6 className="fw-bold text-uppercase mb-3">Explore</h6>
            <ul className="list-unstyled small">
              <li className="mb-2">
                <Link to="/magazines" className="text-white-50 text-decoration-none" onClick={() => window.scrollTo(0, 0)}>
                  Magazines
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/articles" className="text-white-50 text-decoration-none" onClick={() => window.scrollTo(0, 0)}>
                  Books
                </Link>
              </li>
              {/* <li className="mb-2">
                <Link to="/stories" className="text-white-50 text-decoration-none" onClick={() => window.scrollTo(0, 0)}>
                  Stories
                </Link>
              </li> */}
              <li>
                <Link to="/magazines" className="text-white-50 text-decoration-none" onClick={() => window.scrollTo(0, 0)}>
                  Trending
                </Link>
              </li>
            </ul>
          </div>

          <div className="col-md-3">
            <h6 className="fw-bold text-uppercase mb-3">Support</h6>
            <ul className="list-unstyled small">
              <li className="mb-2">
                <Link to="/about" className="text-white-50 text-decoration-none" onClick={() => window.scrollTo(0, 0)}>
                  About Us
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/contact" className="text-white-50 text-decoration-none" onClick={() => window.scrollTo(0, 0)}>
                  Contact Us
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/privacy-policy" className="text-white-50 text-decoration-none" onClick={() => window.scrollTo(0, 0)}>
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-and-conditions" className="text-white-50 text-decoration-none" onClick={() => window.scrollTo(0, 0)}>
                  Terms & Conditions
                </Link>
              </li>
            </ul>
          </div>

          <div className="col-md-3">
            <h6 className="fw-bold text-uppercase mb-3">For Contact</h6>
            <p className="mb-2"><strong>Phone:</strong> {socialLinks.mobile}</p>
            <p className="mb-0"><strong>Email:</strong> {socialLinks.email}</p>
          </div>
        </div>

        <div className="text-center py-3 border-top border-secondary small text-white-50">
          © {new Date().getFullYear()} Porvaall • All Rights Reserved | Developed by Aathesh Soft Solutions.
        </div>
      </div>
    </footer>
  );
}
